import { render, staticRenderFns } from "./ZealInstructorBulkIcard.vue?vue&type=template&id=7b88e964&scoped=true&"
import script from "./ZealInstructorBulkIcard.vue?vue&type=script&lang=js&"
export * from "./ZealInstructorBulkIcard.vue?vue&type=script&lang=js&"
import style0 from "./ZealInstructorBulkIcard.vue?vue&type=style&index=0&id=7b88e964&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b88e964",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VImg,VOverlay,VProgressCircular,VRow})
